import React from "react";
import { Contact, ContactField } from "../types/cardToCrm.types";

interface ContactCardProps {
  contact: Contact;
  index: number;
  onChange: (id: string, field: ContactField, value: string) => void;
  onDelete: (id: string) => void;
}

const FIELDS: { field: ContactField; label: string; type?: string }[] = [
  { field: "name", label: "Name" },
  { field: "title", label: "Title" },
  { field: "company", label: "Company" },
  { field: "email", label: "Email", type: "email" },
  { field: "phone", label: "Phone", type: "tel" },
  { field: "mobile", label: "Mobile", type: "tel" },
  { field: "website", label: "Website", type: "url" },
];

/** A single extracted contact rendered as an inline-editable card. */
const ContactCard: React.FC<ContactCardProps> = ({
  contact,
  index,
  onChange,
  onDelete,
}) => {
  return (
    <div className="relative rounded-xl border border-sagelyn-border bg-sagelyn-surface p-5 shadow-sm">
      <div className="mb-3 flex items-center justify-between">
        <span className="text-xs font-medium uppercase tracking-wide text-sagelyn-muted">
          Contact {index + 1}
        </span>
        <button
          type="button"
          onClick={() => onDelete(contact.id)}
          className="text-sagelyn-muted transition-colors hover:text-red-400"
          aria-label={`Delete contact ${index + 1}`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.8}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 7h12M9 7V5a1 1 0 011-1h4a1 1 0 011 1v2m-7 0v12a1 1 0 001 1h6a1 1 0 001-1V7"
            />
          </svg>
        </button>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {FIELDS.map(({ field, label, type }) => (
          <label key={field}>
            <span className="mb-1 block text-xs font-medium text-sagelyn-muted">
              {label}
            </span>
            <input
              type={type ?? "text"}
              value={contact[field] ?? ""}
              placeholder="—"
              onChange={(e) => onChange(contact.id, field, e.target.value)}
              className="w-full rounded-md border border-sagelyn-border bg-sagelyn-background px-3 py-2 text-sm text-sagelyn-foreground placeholder:text-sagelyn-muted/60 focus:border-sagelyn-primary focus:outline-none focus:ring-1 focus:ring-sagelyn-primary"
            />
          </label>
        ))}
      </div>
    </div>
  );
};

export default ContactCard;
